import { IManualInvoiceLineItemTax } from '@nkr/models/index'
import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    data: IManualInvoiceLineItemTax,
    onYes: () => void,
    onNo: () => void
}

const ConfirmDelete = (props: IProps) => {
    let lineItemTypeDesc = props.data != null ? props.data.lineItemTypeDesc : '';
    let taxRate = props.data != null ? props.data.taxPercent : 0;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>Confirm Deletion of Taxable Line Item</Modal.Header>
            <Modal.Body>
                <Alert bsStyle='danger' bsSize='sm'>Are you sure you want to delete the following item?</Alert>

                <div>Type: {lineItemTypeDesc}</div>
                <div>Tax Rate: {taxRate}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onYes}>Yes, Delete</Button>
                <Button onClick={props.onNo}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDelete;